import styled from 'styled-components';

const LanguageButton = styled.button`
  ${props => props.selected && 'color: #1f275b; font-weight: 600;'};
`;

export default LanguageButton;
